import React from "react";
export const SocketContext = React.createContext({
    prices: {}
});

export const useWebsocket = () => React.useContext(SocketContext);
